import { JOIN_ORGANIZATION } from "constants/routes";
import { checkAccess } from "helpers/auth";
import JoinOrganizationPage from "./container/JoinOrganizationPage";

export default function getSettingsRoute(userAuth) {
  const requireAuth = {};
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: JOIN_ORGANIZATION,
    withSidebar: false,
    withAppBar: false,
    component: JoinOrganizationPage,
  };
}
